import type { BoxInfo, CardInfo } from '@lub0v/santa-utils';
import { useTranslation } from 'react-i18next';
import { DigitCounter } from '@src/components/DigitCounter/DigitCounter';

interface ParticipantCounterProps {
  info: Pick<BoxInfo, 'participantsNumber'>;
  cards: CardInfo[];
  testId?: string;
  onClick?: () => void;
}

export function ParticipantCounter({ info, cards, testId, onClick }: ParticipantCounterProps) {
  const { t, i18n } = useTranslation();
  const count = Math.max(
    info.participantsNumber || 0,
    cards.filter((card) => card.username).length,
  );

  return (
    <DigitCounter
      className="participant-counter"
      value={count}
      label={t('game.main.participantCount', { count })}
      locale={i18n.language}
      testId={testId}
      onClick={onClick}
    />
  );
}
